import React from "react";
import ReactPlayer from "react-player";
import leadingHourse from "../assets/images/svg/leading_hourse.svg";
import hourse_man from "../assets/images/png/hourse_man.png";

const Leading = () => {
  return (
    <>
      {/* =========LEADING-SECTION======= */}
      <section className="m_top_5 overflow-hidden">
        <div className="d-lg-flex">
          <div className="w-100 h-100">
            <div className="position-relative leading_hourse_height w-100">
              <ReactPlayer
                className=" leading_box_img"
                url="https://vz-e28eac45-f0a.b-cdn.net/8f5734a4-2559-4732-9905-a570314d6bd2/playlist.m3u8"
                width="100%"
                playing={true}
                loop={true}
                muted={true}
              />
            </div>
          </div>
          <div className="leading_text_box d-flex align-items-xxl-center position-relative bg_dark_blue px-2 px-sm-3 px-xzl-5 w-100 py-4 py-lg-5 pb-lg-0 text-center text-lg-start">
            <img
              width={120}
              height={165}
              className="position-absolute leading_position"
              src={leadingHourse}
              alt="leadingHourse"
            />
            <div className="ps-xxl-4 leading_para_width  py-sm-5 py-lg-0 pb-xxl-5">
              <h3 className="color-light-white font-lg font-medium ff_josfin mb-2 mb-sm-4 pb-2">
                LEADING THE ACCELERATION BY
              </h3>
              <p className="opacity-07 fw-normal color-light-white font-sm mb-lg-4 opacity_hover_1">
                Leaving A Sustainable Footprint By Developing Our Own Qatari ICS
                Engineering Workforce And Strengthening Our Society’s
                Prosperity.
              </p>
              <p className="opacity-07 fw-normal color-light-white font-sm mb-lg-4 opacity_hover_1">
                Motivating The Workforce To Be On Par And Be Competitive With
                The Top ICS Professionals In The World.
              </p>
              <p className="opacity-07 fw-normal color-light-white font-sm mb-lg-4 opacity_hover_1">
                Keeping Our Dear Citizens And Residents At Peace Regarding Our
                Country’s ICS Security Posture.
              </p>
              <p className="opacity-07 fw-normal color-light-white font-sm mb-lg-4 opacity_hover_1">
                Development Of The Best In Class Technology In Industrial
                Security For Global Partnerships, Diversified Economy And High
                Compliance Standards.
              </p>
              <p className="opacity-07 fw-normal color-light-white font-sm mb-lg-4 opacity_hover_1">
                Securing A High Standard Of Living For All Its People, For The
                Present, And For The Future By Bringing Cyboryx ICS Solutions In
                Our Land’s Economy.
              </p>
              <p className="opacity-07 fw-normal color-light-white font-sm mb-lg-4 opacity_hover_1">
                Global Partnerships With Top International Educational
                Institutions And Enterprises Specialized In OT Automation And
                ICS Security.
              </p>
              <p className="opacity-07 fw-normal color-light-white font-sm mb-0 mb-lg-4 opacity_hover_1">
                Managing Industrial Safety In Our Land, In Order To Bring
                Harmony Between Our Economy Growth, Social Development And
                Environmental Protection.
              </p>
            </div>
          </div>{" "}
        </div>
      </section>
    </>
  );
};

export default Leading;
